import { FC } from 'react';
import { Button, Checkbox } from '@material-ui/core';
import SwitchSelector from 'react-switch-selector';
import { useTheme } from '@material-ui/core/styles';
import { useWallet } from '@solana/wallet-adapter-react';

import { useStyles } from './styles';
import { useViewport } from '../../../../hooks/useViewport';
import { DeviceType } from '../../../../providers/ViewportProvider';

interface FilterBarProps {
  hideEndedRaffles: boolean;
  setHideEndedRaffles: React.Dispatch<React.SetStateAction<boolean>>;
  setShowOwnRafflesOnly: React.Dispatch<React.SetStateAction<boolean>>;
  showOwnRafflesOnly: boolean;
}

const FilterBar: FC<FilterBarProps> = ({
  hideEndedRaffles,
  setHideEndedRaffles,
  setShowOwnRafflesOnly,
  showOwnRafflesOnly,
}) => {
  const { device } = useViewport();
  const classes = useStyles({ device });
  const theme = useTheme();
  const { connected } = useWallet();

  const options = [
    {
      label: 'ALL',
      value: false,
    },
    {
      label: 'MINE',
      value: true,
    },
  ];

  const onOwnRafflesSwitchChange = (newValue: any) => {
    setShowOwnRafflesOnly(newValue);
  };

  // console.log(showOwnRafflesOnly, 'soro');

  return (
    <div className="w-full bg-red-00 md:w-8/12">
      {connected && (
        <div className="w-full z-10 relative flex items-center justify-center md:justify-start space-x-2 py-6">
          <button
            onClick={() => onOwnRafflesSwitchChange(false)}
            className={`lg:px-4 px-1 py-2 primary_font border capitalize border-brand_secondary ${
              !showOwnRafflesOnly
                ? 'bg-brand_accent text-brand_primary'
                : 'bg-brand_primary text-brand_secondary'
            }`}
          >
            Current Raffles
          </button>
          <button
            onClick={() => onOwnRafflesSwitchChange(true)}
            className={`lg:px-4 px-2 py-2 primary_font border capitalize border-brand_secondary ${
              showOwnRafflesOnly
                ? 'bg-brand_accent text-brand_primary'
                : 'bg-brand_primary text-brand_secondary'
            }`}
          >
            My Raffles
          </button>
        </div>
      )}
    </div>
  );
  // return (
  //   <div className={classes.filterBar}>
  //     <div className={classes.middleSection}>
  //       {connected && (
  //         <div className={classes.ownRafflesSwitchContainer}>
  //           <SwitchSelector
  //             onChange={onOwnRafflesSwitchChange}
  //             options={options}
  //             optionBorderRadius={0}
  //             wrapperBorderRadius={0}
  //             fontSize={12}
  //             initialSelectedIndex={0}
  //             selectionIndicatorMargin={0}
  //             selectedBackgroundColor={'#fe005a'}
  //             backgroundColor={'transparent'}
  //             fontColor={'white'}
  //           />
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
};

export default FilterBar;
